import React, { Component } from 'react'
import history from '../../routes/history';
import { connect } from 'react-redux'
import connectCommon from '../common/common-hoc';
import * as actionCreator from '../../redux/actions/data-action';
import { assessmentStatus } from '../../Constants';
import {
    AssessmentContainer,
    AssessmentContentHeader,
    AssessmentBody,
    AssessmentContent,
    AssessmentFooter
} from './common';
import { getLang } from './common/task-utility';

class AssessmentComplete extends Component {
    constructor(props) {
        super(props);

        this.state = { startDate: null };
    }

    componentDidMount() {
        const { setAssessmentStatus, saveData } = this.props;

        setAssessmentStatus(assessmentStatus.Complete);

        saveData();

        this.setState({ startDate: new Date() });

        window.history.pushState(null, null, history.location.href);
        window.onpopstate = function (event) {
            history.go(1);
        };
    }

    render() {
        var lang = getLang(this.props.versionID);


        return (
            <AssessmentContainer>
                <AssessmentContentHeader>{lang === 'fr' ? 'Merci' : lang === 'es' ? 'Gracias' : 'Thank You'}</AssessmentContentHeader>
                <AssessmentBody style={{alignContent: 'center'}}>
                    <AssessmentContent className="assessment-content-introduction">
                        {lang === 'fr' ? (
                            <div>
                                Nous avons reçu vos réponses et nous allons envoyer les résultats à votre administrateur.<br />
                                Pour quitter le site, <b>fermer</b> le navigateur web.
                            </div>
                        ) : lang === 'es' ? (
                            <div>
                                Hemos recibido sus respuestas, y enviaremos los resultados a su Administrador.<br />
                                Para salir de este sitio, <b>cierre</b> su navegador.

                            </div>
                        ) : (
                            <div>
                                We have received your answers, and we will send the results to your administrator.<br/>
                                To exit this site, <b>close</b> your web browser.
                            </div>
                        )}
                    </AssessmentContent>
                </AssessmentBody>
                <AssessmentFooter includeLogo={true}></AssessmentFooter>
            </AssessmentContainer>
        )
    }
}

const mapStateToProps = (state, ownState) => ({
  versionID: state.data.versionID
});

export default connect(mapStateToProps, actionCreator)(connectCommon(AssessmentComplete));